"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THREAD_STATUS = [
    "OPEN",
    "CLOSED",
    "PENDING",
];
//# sourceMappingURL=thread-status.js.map